export default __webpack_public_path__ + "static/media/igiv-logo-full.f3602468.png";